import "core-js/modules/es.error.cause.js";
import { currencyDetail, currencyStore, currencyEdit } from '../request';
import { formatMoney } from '@/utils/public';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        code: '',
        name: '',
        position: 'left',
        separator: 'thousand',
        amountAccuracy: 2,
        unitAccuracy: 2,
        delimiter: undefined,
        useSpaces: false,
        isUse: false,
        showValue: '100000000',
        unit: '',
        symbol: ''
      },
      saveLoading: false
      // ADD_RULES: {
      //   code: [
      //     {required: true, message: this.$t('请输入') + this.$t('货币代码'), trigger: 'change'},
      //     {message: this.$t('请输入') + '2-5' + this.$t('字符'), max: 5, min: 2}
      //   ],
      //   name: [
      //     {required: true, message: this.$t('请输入') + this.$t('货币名称'), trigger: 'change'},
      //     {message: this.$t('请输入') + '2-15' + this.$t('字符'), max: 15, min: 2}
      //   ],
      //   unit: [
      //     {required: true, message: this.$t('请输入') + this.$t('货币单位'), trigger: 'change'},
      //     {message: this.$t('请输入') + '1-5' + this.$t('字符'), max: 5, min: 1}
      //   ],
      //   symbol: [
      //     {required: true, message: this.$t('请输入') + this.$t('货币符号'), trigger: 'change'},
      //     {message: this.$t('请输入') + '1-5' + this.$t('字符'), max: 5, min: 1}
      //   ],
      //   amountAccuracy: [{required: true, message: this.$t('请选择') + this.$t('金额精度'), trigger: 'change'}],
      //   delimiter: [{required: true, validator: validDelimiter, trigger: 'change'}]
      // }
    };
  },
  computed: {
    ADD_RULES() {
      return {
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('货币代码'),
          trigger: 'change'
        }, {
          message: this.$t('请输入') + '2-5' + this.$t('字符'),
          max: 5,
          min: 2
        }],
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('货币名称'),
          trigger: 'change'
        }, {
          message: this.$t('请输入') + '2-15' + this.$t('字符'),
          max: 15,
          min: 2
        }],
        unit: [{
          required: true,
          message: this.$t('请输入') + this.$t('货币单位'),
          trigger: 'change'
        }, {
          message: this.$t('请输入') + '1-5' + this.$t('字符'),
          max: 5,
          min: 1
        }],
        symbol: [{
          required: true,
          message: this.$t('请输入') + this.$t('货币符号'),
          trigger: 'change'
        }, {
          message: this.$t('请输入') + '1-5' + this.$t('字符'),
          max: 5,
          min: 1
        }],
        amountAccuracy: [{
          required: true,
          message: this.$t('请选择') + this.$t('金额精度'),
          trigger: 'change'
        }],
        delimiter: [{
          required: true,
          validator: this.validDelimiter,
          trigger: 'change'
        }]
      };
    }
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  methods: {
    validDelimiter(rule, value, callback) {
      if (this.addForm.isUse) {
        callback();
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error(this.$t('请选择') + this.$t('分隔符')));
        }
      }
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
    },
    resetForm() {
      this.addForm.position = 'left';
      this.addForm.separator = 'thousand';
      this.addForm.showValue = '100000000';
      this.addForm.amountAccuracy = 2;
      this.addForm.unitAccuracy = 2;
      this.addForm.useSpaces = false;
      this.addForm.isUse = false;
      this.$refs.addFormRef.resetFields();
    },
    async getDetail() {
      const res = await currencyDetail({
        id: this.$props.isEdit
      });
      Object.assign(this.addForm, res);
      let symbol = JSON.parse(res.symbol);
      this.addForm.position = symbol.position;
      this.addForm.useSpaces = symbol.useSpaces ? true : false;
      this.addForm.symbol = symbol.mark;
      let delimiter = JSON.parse(res.delimiter);
      this.addForm.separator = delimiter.figure;
      this.addForm.isUse = delimiter.isUse === 0 ? false : true;
      this.addForm.delimiter = delimiter.mark;
      this.exampleBuilder();
    },
    changeUse(e) {
      this.$refs.addFormRef.validateField('delimiter');
      if (this.addForm.isUse) {
        this.addForm.delimiter = undefined;
        this.addForm.separator = 'thousand';
      }
      this.exampleBuilder();
    },
    exampleBuilder() {
      let showPrice = this.addForm.showValue = '100000000';
      showPrice = formatMoney(showPrice, this.addForm.delimiter || '', this.addForm.separator === 'hundred' ? 2 : 3);
      let precision = this.addForm.amountAccuracy > 0 ? '.' : '';
      for (let i = 0; i < this.addForm.amountAccuracy; i++) {
        precision += '0';
      }
      if (this.addForm.position == 'left') {
        this.addForm.showValue = (this.addForm.symbol || '') + (this.addForm.useSpaces ? ' ' : '') + showPrice + precision;
      } else {
        this.addForm.showValue = showPrice + precision + (this.addForm.useSpaces ? ' ' : '') + (this.addForm.symbol || '');
      }
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          this.saveLoading = true;
          let params = {
            code: this.addForm.code,
            name: this.addForm.name,
            unit: this.addForm.unit,
            symbol: JSON.stringify({
              position: this.addForm.position,
              mark: this.addForm.symbol,
              useSpaces: this.addForm.useSpaces ? 1 : 0
            }),
            amountAccuracy: this.addForm.amountAccuracy,
            unitAccuracy: this.addForm.unitAccuracy,
            delimiter: JSON.stringify({
              figure: this.addForm.separator,
              mark: this.addForm.delimiter,
              isUse: this.addForm.isUse ? 1 : 0
            })
          };
          if (this.$props.isEdit) {
            await currencyEdit(Object.assign(params, {
              id: this.$props.isEdit
            }));
          } else {
            await currencyStore(params);
          }
          this.saveLoading = false;
          this.$emit('save');
          this.closeAddVisible();
        }
      });
    }
  }
};